import type {Transaction} from 'shared/src/models';

export const getTransactionsTotal = (transactions: Transaction[]): number => {
	return transactions.reduce((total, transaction) => total + transaction.amount, 0);
};
